// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"SkeletonLoader_loaderWrapper__LOcl0"};